export const API_URL = "https://api.volocal.net";

export const GOOGLE_CLIENT_ID =
  "956842871620-5ngmi5jaa5vdc3c3de1oqf4n5keqsocb.apps.googleusercontent.com";

export const STRIPE_BUTTON_ID = "buy_btn_1O4nRqHyTtAMgk86hCYqwYDh";
export const STRIPE_PUBLISHABLE_KEY =
  "pk_live_51O3oeMHyTtAMgk861Sz7maBZYPX5e8fphzHLImLyHVuke7nzByOYSu8j8tV95nWJ4NsJeys8BC7ixKIGnvj1Zq2I00D2Ql3zim";
export const STRIPE_CUSTOMER_PORTAL_ID = "3cs6qn7kher44es4gg";
